'use strict';

var App = require('app');
var AppState = require('app_state');
var ColorPicker = require('utils/colorpicker');
var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');

var ConfigureChartDialogView = Marionette.ItemView.extend({
    defaultColors: [
        // stylguide colors
        'rgb(86, 130, 166)', // #5682A6 - Blue
        'rgb(126, 185, 184)', // #7EB9B8 - Teal
        'rgb(233, 136, 80)', // #E98850 - Orange
        'rgb(140, 122, 255)', // #8C7AFF - Purple
        'rgb(222, 162, 201)', // #DEA2C9 - Rose
        'rgb(187, 164, 142)', // #BBA48E - Beige

        // .. more colors .. (not from styleguide)
        'rgb(255, 0, 255)',
        'rgb(150, 75, 0)',
        'rgb(192, 0, 0)',
        'rgb(0, 0, 128)',
        'rgb(192, 0, 92)',
        'rgb(92, 92, 92)',
    ],

    deviceSeries: {},
    maxSeries: 8,

    aggregationFunc: [
        { name: I18N.TR('Durchschnitt'), value: 'MEAN' },
        { name: I18N.TR('Minimum'), value: 'MIN' },
        { name: I18N.TR('Maximum'), value: 'MAX' },
        { name: I18N.TR('Maximum/Differenz'), value: 'MAXD', difference: 1, func: 'MAX' },
    ],

    template: require('components/devices/templates/common/chart_configure'),
    colorTemplate: require('components/devices/templates/common/chart_configure_line_color'),

    ui: {
        chkOnlyThisDevice: '#js-cb-only-this-device',
        ddlChartType: '.js-display-type',
        ddlTimeWindow: '.js-display-timewindow',
        ddlAggregation: '.js-display-aggregation',
        ddlDiff: '.js-display-diff',
    },

    // data set by the user
    dataContext: { lines: [] },

    events: {
        'click #ct-advanced': function () {
            this.dataContext.advancedMode = !this.dataContext.advancedMode;
            if (!this.dataContext.advancedMode) this.clearAdvancedData();
            this.doRender();
            this.updateDialogClass();
        },

        'change @ui.chkOnlyThisDevice': function () {
            this.onlyThisDevice = this.ui.chkOnlyThisDevice.prop('checked');
        },

        'change select.js-input': function (e) {
            this.triggerChange(e.currentTarget);
        },

        'click .js-chart-select-row-delete': function (e) {
            var r = this.findRow(e.currentTarget);
            this.deleteRow(r);
        },

        'click .js-operator': function (e) {
            var r = this.findRow(e.currentTarget);
            this.saveLine(r.idx, r.row, false);

            var op = $(e.currentTarget).attr('data-op');
            this.dataContext.lines[r.idx].operator = op;
            if (op && !this.dataContext.lines[r.idx].device2ID) this.dataContext.lines[r.idx].device2ID = this.deviceID;
            this.doRender(r.idx);
        },

        'change input.js-input': function (e) {
            var self = this;
            var r = this.findRow(e.currentTarget);
            this.triggerChange(e.currentTarget, false);

            // add series (when needed)
            this.dataContext.lines.forEach(function (l) {
                l.series = l.series || self.deviceSeries[l.deviceID];
                l.series2 = l.series2 || self.deviceSeries[l.device2ID];
            });

            $(r.row)
                .find('.js-chart-label')
                .text(
                    Misc.getChartLineLabel(
                        r.idx,
                        { lines: self.dataContext.lines, devices: self.allDevices },
                        true,
                        AppState
                    )
                );
        },

        'click .js-is-prepare-data': function (e) {
            var self = this;
            if (!$(e.currentTarget).prop('checked')) {
                var r = this.findRow(e.currentTarget);
                if (this.dataContext.lines[r.idx].style == 1) {
                    var count = Misc.countWhere(this.dataContext.lines, function (l) {
                        return l.style == 1 && l != self.dataContext.lines[r.idx];
                    });
                    if (count == 0) {
                        this.dataContext.timeWindow = -1;
                    }
                }
            }
        },

        'click .js-checkbox-adv': function (e) {
            var value = $(e.currentTarget).prop('checked') ? 1 : 0;
            var r = this.findRow(e.currentTarget);
            this.saveLine(r.idx, r.row, false);
            this.doRender(r.idx);
        },

        'change select.js-bar-time-window': function (e) {
            var value = $(e.currentTarget).val();
            var r = this.findRow(e.currentTarget);
            this.dataContext.timeWindow = value;
            this.saveLine(r.idx, r.row, false); // in order to keep the current selected line
            this.doRender(r.idx);
        },

        'click .js-delete': function (e) {
            var r = this.findRow(e.currentTarget);
            this.deleteRow(r);
        },

        'click #ct-save': function (e) {
            var self = this;
            var aggregation = {};
            _.each(this.aggregationFunc, function (a) {
                aggregation[a.value] = a;
            });

            this.removeEmpty();

            var result = Misc.selectWhere(
                this.dataContext.lines,
                function (a) {
                    return a.field;
                },
                function (a, index) {
                    var loc = AppState.getDeviceInfo(a.deviceID).location || [];
                    var loc2 = AppState.getDeviceInfo(a.device2ID).location || [];

                    var obj = {
                        deviceID: '' + a.deviceID,
                        field: a.field,
                        secondDeviceID: '' + a.device2ID,
                        secondField: a.field2,
                        op: a.operator,
                        customLabel: a.customLabel,
                        color: a.color,
                        lon: loc[0],
                        lat: loc[1],
                        lon2: loc2[0],
                        lat2: loc2[1],
                        index: index,
                        displaySettings: {
                            timeshift: a.showTimeShift
                                ? {
                                      mode: a.timeShiftMode,
                                      diff: a.timeShiftDiff,
                                      unit: a.timeShiftDiffUnit,
                                      ref: moment(a.timeShiftDate + ' ' + a.timeShiftTime, 'DD.MM.YYYY hh:mm').unix(),
                                  }
                                : undefined,
                            chartType: parseInt(a.style),
                            difference: parseInt(a.aggregationFunc ? aggregation[a.aggregationFunc].difference : 0),
                            aggregationFunc: a.aggregationFunc
                                ? aggregation[a.aggregationFunc].func || aggregation[a.aggregationFunc].value
                                : 'MEAN',
                            timeWindow: parseInt(self.dataContext.timeWindow) || Consts.ChartTimeWindows()[0].id,
                        },
                    };

                    obj = $.extend(
                        true,
                        {},
                        Misc.selectWhereFirst(self.deviceSeries[a.deviceID], function (b) {
                            return a.field == b.field;
                        }) ||
                            Misc.selectWhereFirst(Consts.WeatherData, function (b) {
                                return a.field == b.field;
                            }) ||
                            Misc.selectWhereFirst(Consts.SmartTempData, function (b) {
                                return a.field == b.field;
                            }),
                        obj
                    );

                    if (obj.secondDeviceID && obj.secondField) {
                        obj.secondFieldInfo = Misc.selectWhereFirst(
                            self.deviceSeries[obj.secondDeviceID],
                            function (b) {
                                return obj.secondField == b.field;
                            }
                        );
                    }

                    return obj;
                }
            );
            this.onSaveData(result, this.onlyThisDevice, this.dataContext.advancedMode);
        },
    },

    updateDialogClass: function () {
        if (this.dataContext.advancedMode) $('#js-modal-dialog .modal-dialog').addClass('modal-lg');
        else $('#js-modal-dialog .modal-dialog').removeClass('modal-lg');
    },

    deleteRow: function (r) {
        this.dataContext.lines.splice(r.idx, 1);
        this.updateLines();
        this.doRender();
    },

    newLine: function () {
        var l = { deviceID: this.deviceID, style: 0, color: this.getNextColor() };
        return l;
    },

    hasAggregationNoWeather: function (src) {
        return !!Misc.selectWhereFirst(src, function (item) {
            return item.style > 0 && !Misc.isWeatherField(item.field) && !Misc.isWeatherField(item.field2);
        });
    },

    serializeData: function () {
        var self = this;
        // check if the selected value is always available (when not, choose the first one)
        _.each(this.dataContext.lines, function (line) {
            var deviceID = parseInt(line.deviceID);
            var device2ID = parseInt(line.device2ID);

            var checkField = function (fld, checkDeviceID) {
                if (fld === undefined) return;

                var series = self.deviceSeries[checkDeviceID];
                var cnt =
                    Misc.selectWhere(series, function (item) {
                        return item.field == fld;
                    }).length ||
                    Misc.selectWhere(Consts.WeatherData, function (item) {
                        return item.field == fld;
                    }).length ||
                    Misc.selectWhere(Consts.SmartTempData, function (item) {
                        return item.field == fld;
                    }).length;
                if (!cnt && series && series.length > 0) {
                    return series[0].field;
                }
                return fld;
            };

            line.field = checkField(line.field, deviceID);
            if (line.field2 && line.device2ID && line.operator) {
                line.field2 = checkField(line.field2, device2ID);
            }
        });

        // add data set by the app
        var data = $.extend(true, {}, this.dataContext);

        // add a new line, if there is still space
        if (
            data.lines &&
            data.lines.length < this.maxSeries &&
            Misc.countWhere(data.lines, function (a) {
                return !a.field;
            }) == 0
        ) {
            data.lines.push(this.newLine());
        }

        // add series to devices
        var actualLineCount = Misc.countWhere(this.dataContext.lines, function (a) {
            return a.deviceID && a.field;
        });
        var isAdmin = AppState.user.attributes.is_admin;

        var hasAggregationNoWeather = this.hasAggregationNoWeather(data.lines);
        var timeWindows = Misc.selectWhere(Consts.ChartTimeWindows(), function (item) {
            return item.weatherData || hasAggregationNoWeather;
        });
        var selectedTimeWindow = Misc.selectWhereFirst(timeWindows, function (item) {
            return item.id == data.timeWindow;
        });

        _.each(
            data.lines,
            function (l, idx) {
                l.series = self.deviceSeries[l.deviceID];

                l.index = idx;
                l.showCustomLabel = l.showCustomLabel || l.customLabel;
                l.showEmptySerie = actualLineCount > 1 || !l.field;
                l.showPrepareData =
                    l.showPrepareData ||
                    (l.aggregationFunc && l.aggregationFunc != 'MEAN') ||
                    l.style == 1 ||
                    l.style == 2 ||
                    l.difference;

                l.hasWeatherData = !!AppState.getDeviceInfo(l.deviceID).location;

                // smart temp data
                var smartTempStatus = self.smartTempInfo[l.deviceID];
                l.hasSmartTempData = !smartTempStatus.isInactive();
                l.smartTempData = self.getSmartTempDatapoints(smartTempStatus, l.deviceID);

                if (parseInt(l.device2ID)) {
                    l.series2 = self.deviceSeries[l.device2ID];
                    l.hasWeatherData2 = !!AppState.getDeviceInfo(l.device2ID).location;
                    var smartTempStatus2 = self.smartTempInfo[l.device2ID];
                    l.hasSmartTempata2 = !smartTempStatus2.isInactive();
                    l.smartTempData2 = self.getSmartTempDatapoints(smartTempStatus2, l.device2ID);
                }

                l.isWeatherField = Misc.isWeatherField(l.field) || Misc.isWeatherField(l.field2);
                l.disableTimeWindow = l.isWeatherField && hasAggregationNoWeather;
                l.showTimeWindowWarning = l.disableTimeWindow && selectedTimeWindow && !selectedTimeWindow.weatherData;
            },
            isAdmin
        );

        data.canDelete = this.dataContext.lines.length > 1;
        if (Misc.countWhere(data.lines, 'isSelected') === 0) {
            var idx = 0;
            data.lines[idx].isSelected = true;
        }
        data.operators = Consts.Backend.Operators;
        data.timeWindows = timeWindows;

        data.aggregationFunc = this.aggregationFunc;
        data.count = this.dataContext.lines.length;
        data.mainDeviceID = this.deviceID;
        data.onlyThisDevice = this.onlyThisDevice;

        data.smartTempData = AppState.features[Consts.Features.SmartTemp] ? Consts.SmartTempData : {};
        data.weatherData = AppState.features[Consts.Features.WeatherData] ? Consts.WeatherData : {};

        // time shift
        data.timeShiftModes = [Consts.ChartTimeShift.Mode.RELATIVE, Consts.ChartTimeShift.Mode.WITH_DATE];
        data.timeShiftDiffUnits = [
            Consts.ChartTimeShift.Unit.MINUTES,
            Consts.ChartTimeShift.Unit.HOURS,
            Consts.ChartTimeShift.Unit.DAYS,
            Consts.ChartTimeShift.Unit.MONTHS,
            Consts.ChartTimeShift.Unit.YEARS,
        ];

        data.timeShiftDiffs = [];
        for (var i = 1; i <= 60; i++) {
            data.timeShiftDiffs.push({ id: i, name: '' + i });
        }
        return data;
    },

    getSmartTempDatapoints: function (smartTempInfo, deviceID) {
        var isAdmin = AppState.user.attributes.is_admin;
        var category = AppState.getDeviceInfo(deviceID).category;
        var result = [];
        if (smartTempInfo.isInactive()) {
            return result;
        }

        _.each(Consts.SmartTempData, function (obj) {
            if (
                obj.category === category &&
                (!obj.adminOnly || isAdmin) &&
                (!obj.activeOnly || smartTempInfo.isActive()) &&
                (!obj.hc || smartTempInfo.getOptimizedHCs(true).includes(obj.hc))
            ) {
                result.push(obj);
            }
        });

        if (
            category === Consts.Category.Controller &&
            _.any(smartTempInfo.getActiveModels(true), function (obj) {
                return obj.get('MustModifyOutdoorSensor');
            })
        ) {
            _.each(Consts.SmartTempData, function (obj) {
                if (obj.hc === 'AF') {
                    result.push(obj);
                }
            });
        }
        return result;
    },

    onRender: function () {
        Misc.initDatePicker();
        Misc.initTimePicker();
        Misc.initSelectPicker();
        Misc.initDevicePicker({
            filter: function () {
                return { locations: true };
            },
        });
        this.initColorButtons('.js-chart-row');
    },

    onShow: function () {
        Misc.initSelectPicker();
        Misc.initDatePicker();
        Misc.initTimePicker();
        Misc.initDevicePicker({
            filter: function () {
                return { locations: true };
            },
        });
        this.initColorButtons('.js-chart-row');
        this.updateDialogClass();
        this.updateDevices();
    },

    updateDevices: function () {
        // list all devices
        var self = this;

        var list = _.uniq(
            _.flatten(
                Misc.selectWhere(this.dataContext.lines, undefined, function (a) {
                    return [a.deviceID, a.device2ID];
                })
            )
        );

        var missingDevices = Misc.selectWhere(
            list,
            function (a) {
                return parseInt(a) && !self.deviceSeries[a];
            },
            undefined,
            true
        );

        if (missingDevices.length == 0) return;

        var reqs = Misc.selectWhere(missingDevices, undefined, function (id) {
            return App.request('device:values', id);
        });

        $.when.apply($, reqs).done(function () {
            var r = arguments;
            _.each(arguments, function (a) {
                var data = a.toJSON();
                _.each(data, function (row) {
                    row.field = row.type + '_' + row.nr;
                    row.isBinary = row.field.substr(0, 3) == 'MBC';
                });
                self.deviceSeries[a.deviceID] = data;
            });

            self.render();
        });
    },

    initialize: function (data) {
        var self = this;
        this.deviceID = data.deviceID;
        this.deviceSeries = data.deviceSeries;
        this.smartTempInfo = data.smartTempInfo;
        this.onSaveData = data.saveData;
        this.dataContext.advancedMode = data.advancedMode;
        this.dataContext.lines = _.map(data.selectedSeries, function (a) {
            var ds = a.displaySettings || {};
            if (ds.timeWindow) {
                self.dataContext.timeWindow = ds.timeWindow;
            }

            return {
                showTimeShift: !!ds.timeshift,
                timeShiftMode: ds.timeshift && ds.timeshift.mode,
                timeShiftDiff: ds.timeshift && ds.timeshift.diff,
                timeShiftDiffUnit: ds.timeshift && ds.timeshift.unit,
                timeShiftDate: ds.timeshift && moment.unix(ds.timeshift.ref).format('DD.MM.YYYY'),
                timeShiftTime: ds.timeshift && moment.unix(ds.timeshift.ref).format('HH:mm'),
                showPrepareData: ds.chartType == 1 || ds.chartType == 2,
                deviceID: a.deviceID,
                field: a.field,
                device2ID: a.secondDeviceID,
                field2: a.secondField,
                customLabel: a.customLabel,
                operator: a.op,
                color: a.color,
                style: ds.chartType,
                aggregationFunc: self.getAggregationFunc(ds),
            };
        });
    },

    getAggregationFunc: function (ds) {
        return Misc.selectWhereFirst(
            this.aggregationFunc,
            function (a) {
                return (a.func || a.value) == ds.aggregationFunc && (a.difference == 1) == (ds.difference == 1);
            },
            function (a) {
                return a.value;
            }
        );
    },

    initColorButtons: function (owner) {
        var self = this;
        var createColorButtons = function (originalColor) {
            var colors = _.toArray($.extend(true, [], self.defaultColors));
            colors.push(undefined);
            for (var i = 0; i < colors.length; i++) {
                colors[i] = {
                    color: colors[i] === undefined ? originalColor : colors[i],
                    custom: colors[i] === undefined,
                };
            }
            return self.colorTemplate({
                colors: colors,
            });
        };

        var btnSelector = $(owner).find('button.js-chart-select-row-color');
        btnSelector.popover({
            html: true,
            animation: true,
            placement: 'right',
            trigger: 'click',
            sanitizeFn: function (x) {
                return x;
            },
            content: function (e) {
                return createColorButtons($(this).css('background-color'));
            },
            title: function (e) {
                return I18N.TR('Wählen Sie bitte eine Farbe aus');
            },
        });

        btnSelector.on('click', function (e) {
            $(e.target).popover('toggle');
        });

        btnSelector.on('hide.bs.popover', function (e) {
            if (!self.colorButtonClicked && self.colorSelected) {
                $(e.target).css(
                    'background-color',
                    $(e.target).next().find('button.js-custom-color').css('background-color')
                );
                self.triggerChange(e.target);
            }

            self.colorButtonClicked = undefined;
            self.colorSelected = undefined;
        });

        btnSelector.on('shown.bs.popover', function (e) {
            $(e.target)
                .next()
                .find('button')
                .on('mousedown', function (btn) {
                    self.colorButtonClicked = true;
                    var btn = $(btn.target).closest('button');
                    var selectedColor = $(btn).css('background-color');

                    var r = self.findRow(e.currentTarget);
                    r.row.find('.js-chart-select-row-color').css('background-color', selectedColor);

                    self.triggerChange(e.target);
                });

            var ctrlCustomColor = $(e.target).next().find('button.js-custom-color');
            ctrlCustomColor = $('button.js-custom-color');
            var cp = new ColorPicker(ctrlCustomColor, {
                wrapperClass: 'chart-color-select',
                owner: '.chart-colorpicker',
            });

            $(e.target)
                .parent()
                .find('canvas')
                .on('mousedown', function () {
                    self.colorSelected = true;
                });
        });
    },

    findRow: function (e) {
        var row = $(e).closest('.js-chart-row');
        var idx = row.attr('data-row-index');
        return { row: row, idx: parseInt(idx) };
    },

    triggerChange: function (e, doRender) {
        var r = this.findRow(e);
        this.saveLine(r.idx, r.row, doRender);
    },

    saveLine: function (idx, row, doRender) {
        var self = this;
        var isExisting = this.dataContext.lines[idx] !== undefined;
        this.dataContext.lines[idx] = this.dataContext.lines[idx] || this.newLine();
        var dataContextLine = this.dataContext.lines[idx];
        dataContextLine.field = $(row).find('select.js-series').val();
        dataContextLine.color =
            $(row).find('.js-chart-select-row-color').css('background-color') || this.getNextColor();
        if (this.dataContext.advancedMode) {
            // save additional data
            var $row = $(row);
            var isCustomLabelChecked = $(row).find('input.js-is-custom-label').prop('checked');
            var isOperator = $(row).find('input.js-is-operator').prop('checked');
            var isPrepareData = $(row).find('input.js-is-prepare-data').prop('checked');
            var isBarChart = $(row).find('input.js-cb-histogram').prop('checked');
            var isLineAggChart = isPrepareData && !isBarChart;
            var isTimeShift = $(row).find('input.js-is-time-shift').prop('checked');

            if (dataContextLine.showTimeShift || !isTimeShift) {
                // read time shift settings from the form
                dataContextLine.timeShiftMode = parseInt($(row).find('select.js-time-shift-mode').val());
                dataContextLine.timeShiftDiff = parseInt(
                    $(row).find('select.js-time-shift-diff').val() || dataContextLine.timeShiftDiff
                );
                dataContextLine.timeShiftDiffUnit =
                    $(row).find('select.js-time-shift-diff-unit').val() || dataContextLine.timeShiftDiffUnit;
                dataContextLine.timeShiftDate =
                    $(row).find('input.js-time-shift-date').val() || dataContextLine.timeShiftDate;
                dataContextLine.timeShiftTime =
                    $(row).find('input.js-time-shift-time').val() || dataContextLine.timeShiftTime;
            } else {
                // fill time shift default settings
                dataContextLine.timeShiftMode = Consts.ChartTimeShift.Mode.RELATIVE.id;
                dataContextLine.timeShiftDiff = 1;
                dataContextLine.timeShiftDiffUnit = Consts.ChartTimeShift.Unit.DAYS.id;
                dataContextLine.timeShiftDate = moment().format('DD.MM.YYYY');
                dataContextLine.timeShiftTime = moment().format('hh:mm');
            }
            dataContextLine.showTimeShift = isTimeShift;

            dataContextLine.deviceID = parseInt($(row).find('select.js-device').val());
            if (isOperator) {
                // if the operator is set already, get the data from the form
                if (dataContextLine.operator) {
                    dataContextLine.device2ID = parseInt($(row).find('select.js-device2').val());
                    dataContextLine.field2 = $(row).find('select.js-series2').val();
                } else {
                    // operator is not known - set defaults
                    dataContextLine.device2ID = dataContextLine.deviceID;
                    dataContextLine.field2 = '';
                    dataContextLine.operator = '+';
                }
            } else {
                dataContextLine.operator = '';
                dataContextLine.field2 = '';
                dataContextLine.device2ID = undefined;
            }

            if (isPrepareData) {
                dataContextLine.difference = $(row).find('select.js-difference').val();
                dataContextLine.aggregationFunc = $(row).find('select.js-aggregation-func').val();
            } else {
                dataContextLine.difference = 0;
                dataContextLine.aggregationFunc = 'MEAN';
            }

            if (isBarChart && dataContextLine.timeWindow <= 0) dataContextLine.timeWindow = 1;

            dataContextLine.showCustomLabel = isCustomLabelChecked;
            dataContextLine.showPrepareData = isPrepareData || isBarChart;
            dataContextLine.customLabel = isCustomLabelChecked ? $(row).find('input.js-custom-label').val() : '';
            dataContextLine.showCustomLabel = dataContextLine.customLabel || isCustomLabelChecked;
            dataContextLine.style = isBarChart ? 1 : isLineAggChart ? 2 : 0;

            // update the selection
            _.each(this.dataContext.lines, function (a) {
                a.isSelected = false;
            });
            _.each($('.panel-collapse.in').closest('.js-chart-row'), function (a) {
                var r = $(a).attr('data-row-index');
                self.dataContext.lines[r].isSelected = true;
            });
        } else {
            this.dataContext.lines[idx].deviceID = this.deviceID;
        }

        this.updateLines();

        if (doRender !== false) {
            this.doRender(this.dataContext.lines[idx] ? idx : undefined);
        }
    },

    updateLines: function () {
        var hasAggNoWeather = this.hasAggregationNoWeather(this.dataContext.lines);
        var dc = this.dataContext;
        if (!hasAggNoWeather) {
            _.each(this.dataContext.lines, function (a) {
                if (a.style == 0) {
                    return;
                }
                // because there are no aggregated non-weather values, this one has to be weather value
                var isWeatherTimeWindow = !!Misc.selectWhereFirst(Consts.ChartTimeWindows(), function (x) {
                    return x.id == dc.timeWindow && x.weatherData;
                });
                if (isWeatherTimeWindow) {
                    return;
                }

                var opt = Misc.selectWhereFirst(Consts.ChartTimeWindows(), function (x) {
                    return x.weatherData;
                });
                dc.timeWindow = opt.id;
            });
        }
    },

    removeEmpty: function () {
        this.dataContext.lines = Misc.selectWhere(this.dataContext.lines, function (a) {
            return a.field && a.deviceID;
        });
    },

    doRender: function (line) {
        // no line given? just render
        if (line === undefined) {
            this.render();
            return;
        }

        var dataContextLine = this.dataContext.lines[line];
        if (this.isDeviceLoaded(dataContextLine.deviceID) && this.isDeviceLoaded(dataContextLine.device2ID)) {
            this.render();
        } else {
            this.reloadDevices(dataContextLine);
        }
    },

    isDeviceLoaded: function (deviceID) {
        if (!deviceID) return true;
        return this.deviceSeries[deviceID] !== undefined;
    },

    reloadDevices: function (dataLine) {
        var self = this;
        // create requests
        var valueReqs = [];
        var optReqs = [];
        var ids = [];
        _.each([dataLine.deviceID, dataLine.device2ID], function (id) {
            if (parseInt(id) && self.deviceSeries[id] === undefined) {
                valueReqs.push(App.request('device:values', id));
                optReqs.push(App.request('device:smarttemp', id));
                ids.push(id);
            }
        });

        $.when.apply($, valueReqs.concat(optReqs)).done(function () {
            var values = Array.prototype.slice.apply(arguments, [0, valueReqs.length]);
            var smartTempInfo = Array.prototype.slice.apply(arguments, [valueReqs.length, arguments.length]);
            _.each(values, function (a) {
                var data = a.toJSON();
                _.each(data, function (row) {
                    row.field = row.type + '_' + row.nr;
                    row.isBinary = row.field.substr(0, 3) == 'MBC';
                });

                self.deviceSeries[a.deviceID] = data;
            });
            _.each(ids, function (id, i) {
                self.smartTempInfo[id] = smartTempInfo[i];
            });

            self.render();
        });
    },

    getNextColor: function () {
        var self = this;
        for (var i = 0; i < this.defaultColors.length; i++) {
            var found = false;
            _.each(this.dataContext.lines, function (l) {
                found = found || l.color === self.defaultColors[i];
            });

            if (!found) {
                return this.defaultColors[i];
            }
        }

        return this.defaultColors[0];
    },

    clearAdvancedData: function () {
        var self = this;
        _.each(this.dataContext.lines, function (l) {
            _.each(
                [
                    'aggregationFunc',
                    'customLabel',
                    'device2ID',
                    'difference',
                    'field2',
                    'operator',
                    'showCustomLabel',
                    'showPrepareData',
                    'showTimeShift',
                    'style',
                    'timeShiftDate',
                    'timeShiftDiff',
                    'timeShiftDiffUnit',
                    'timeShiftMode',
                    'timeShiftTime',
                ],
                function (fld) {
                    delete l[fld];
                }
            );
            l.deviceID = self.deviceID;
        });
        this.dataContext.lines = _.uniq(this.dataContext.lines, function (l) {
            return l.field;
        });
    },
});

module.exports = ConfigureChartDialogView;
